export default __webpack_public_path__ + "static/media/imgFundamentos.bcb7219d.png";